// Structured bio starter — Ivon's canonical sections (2026-07-09):
// Introduction · Experience · Best thing about Onda · What I do best ·
// What I love about style · Am I on socials · My WebShop.
// Roadmap: AI pre-fills this from a scrape of the stylist's confirmed socials
// (mentions like "check these foils" become specialities + photo tags).

export const SERVICE_LABELS = {
  haircut: 'Haircut',
  coloring: 'Colouring',
  styling: 'Styling',
  facial: 'Facial',
  nails: 'Nails',
  threading: 'Threading',
  waxing: 'Waxing',
  cosmetic_tattoo: 'Cosmetic Tattoo',
  massage: 'Massage',
};

export const BIO_LINES = {
  haircut: 'precision cuts tailored to face shape and lifestyle',
  coloring: 'balayage to bold fashion colours',
  styling: 'event-ready styling — weddings, shoots, occasions',
  facial: 'skin-first facials that leave you glowing',
  nails: 'detailed nail artistry',
  threading: 'clean, precise brow threading',
  waxing: 'gentle professional waxing',
  cosmetic_tattoo: 'natural-look cosmetic tattooing',
  massage: 'restorative massage',
};

export function buildBioTemplate({ firstName, years, skills = [] } = {}) {
  const role = skills.length ? (SERVICE_LABELS[skills[0]] || 'beauty').toLowerCase() : '[your craft]';
  const specialities = skills.map((k) => BIO_LINES[k]).filter(Boolean).join('; ');
  return [
    `✨ Hi, my name is ${firstName || '[your name]'}!`,
    ``,
    `💼 I have over ${years || '[X]'} years as a ${role} stylist — trained at [your academy].`,
    ``,
    `💛 The best thing about Onda? It organises my day and promotes my brand — I can work anywhere, anytime.`,
    ``,
    `✂️ What I do best: ${specialities || '[your specialities]'}. I work with premium products from [your favourite brands].`,
    ``,
    `🌟 What I love about style: [the transformations, the trends, the confidence].`,
    ``,
    `📱 Am I on socials? Yes — see my links and follow my trends!`,
    ``,
    `🛍️ My WebShop: curated favourites and specialised treatment prescriptions — ask me!`,
  ].join('\n').slice(0, 1000);
}
